'use strict';

angular.module('amexReconciliationApp')
  .component('preauthDataPanel', {
    templateUrl: 'scripts/views/components/preauth-data-panel.html',
    controller: function (ActiveTransactionModel) {
      var self = this;
      self.preAuth = {};

      self.$onInit = function () {
        self.preAuth = ActiveTransactionModel.activeTransaction().preAuthData[0];
        getUdfList(self.preAuth);
      };

      function getUdfList(preAuthData) {
        self.preAuthUdfs = getValues(preAuthData, 1, 3, 'preAuthUserDefinedField');
        self.udfs = getValues(preAuthData, 1, 12, 'ngUserDefinedField');
        self.accountingFields = getValues(preAuthData, 1, 8, 'ngAccountingField');
      }

      function getValues(preAuthData, start, end, name) {
        var fields = [];

        _.each(_.range(start, end + 1), function (number) {
          var field = preAuthData[name + number];
          if (!_.isNil(field) && field.trim() !== '') {
            fields.push({'field': field,'index': number});
          }
        });

        return fields;
      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/preauthDataPanel.js
// module id = 466
// module chunks = 0